import { Component, OnInit } from '@angular/core';
import { AuthenticationService, TokenPayload, TestData } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { TestTakerService } from '../services/test_taker.service';
import { TestSchedulerService } from '../services/test_scheduler.service';
import Swal from 'sweetalert2';


@Component({
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditAdminComponent implements OnInit {
  credentials: TokenPayload = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    phone: '',
    type: ''
  };
  result: string[];
  AdminColor: boolean;
  SuperAdminColor: boolean;
  TestSchedulerColor: boolean;
  TestTakerColor: boolean;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  details: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  overall: boolean;
  registerForm: FormGroup;
  submitted = false;
  Type;
  user;
  name;
  id;
  first_name;
  last_name;
  pmail;
  Password;
  phone;
  type;
  Role;

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  email;
  fname;
  lname;
  columns: string[];
  // tslint:disable-next-line: max-line-length
  constructor(private auth: AuthenticationService, private route: ActivatedRoute,
    private router: Router, private formBuilder: FormBuilder, private testtakerservice: TestTakerService,
    private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.minLength(9)]]
      // type: ['', Validators.required]
    });
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });


    this.get_user_type();

  }

  get f() {
    return this.registerForm.controls;
  }

  get_user_type() {
    this.auth.get_user_type(this.id).subscribe(
      (data) => {

        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');



        if (this.user === '2') {

          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = true;
          this.userTestTaker = true;
          this.questionset = true;
          this.scheduletest = true;
          this.evaluate = true;
          this.overall = true;
          this.details = true;
        } else if (this.user === '1') {
          this.userAdmin = true;
          this.userSuperAdmin = true;
          this.userTestScheduler = true;
          this.userTestTaker = true;
          this.questionset = true;
          this.scheduletest = true;
          this.evaluate = true;
          this.overall = true;
          this.details = true;
        } else if (this.user === '3') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = false;
          this.userTestTaker = true;
          this.questionset = true;
          this.scheduletest = true;
          this.evaluate = true;
          this.overall = true;
          this.details = false;
        } else if (this.user === '4') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = false;
          this.userTestTaker = false;
          this.questionset = false;
          this.scheduletest = false;
          this.evaluate = false;
          this.overall = false;
          this.details = false;
        }

        this.Role = data.results[0].type;

        if (this.Role === 1) {
          this.SuperAdminColor = true;
          this.AdminColor = false;
          this.TestSchedulerColor = false;
          this.TestTakerColor = false;
        } else if (this.Role === 2) {

          this.SuperAdminColor = false;
          this.AdminColor = true;
          this.TestSchedulerColor = false;
          this.TestTakerColor = false;
        } else if (this.Role === 3) {
          this.SuperAdminColor = false;
          this.AdminColor = false;
          this.TestSchedulerColor = true;
          this.TestTakerColor = false;
          this.questionset = true;
          this.scheduletest = true;
          this.evaluate = true;
          this.overall = true;
        } else if (this.Role === 4) {
          this.SuperAdminColor = false;
          this.AdminColor = false;
          this.TestSchedulerColor = false;
          this.TestTakerColor = true;
        }

        this.result = data.results;
        this.credentials.id = data.results[0].id;
        this.credentials.first_name = data.results[0].first_name;
        this.credentials.last_name = data.results[0].last_name;
        this.credentials.email = data.results[0].email;
        this.credentials.phone = data.results[0].phone;
        this.credentials.type = data.results[0].type;


      },
      err => {
        console.error(err);
      }
    );
  }

  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {


        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


        if (this.user === '2') {

          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = true;
          this.userTestTaker = true;
          this.details = true;
          this.result = data.results;
          return this.result;
        } else if (this.user === '1') {
          this.userAdmin = true;
          this.userSuperAdmin = true;
          this.userTestScheduler = true;
          this.userTestTaker = true;
          this.details = true;
          this.result = data.results;
          return this.result;
        } else if (this.user === '3') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = false;
          this.userTestTaker = true;
          this.details = false;
        } else if (this.user === '4') {
          this.userAdmin = false;
          this.userSuperAdmin = false;
          this.userTestScheduler = false;
          this.userTestTaker = false;
          this.details = false;
        }
      },
      err => {
        console.error(err);
      }
    );
  }


  update() {
    this.submitted = true;

    if (this.registerForm.invalid) {


      return;
    } else {
      this.Type = this.credentials.type;

      if (this.Type === 1) {
        this.auth.update(this.credentials).subscribe(
          (data) => {

            if (data.code === 200) {
             
              Swal.fire({
                title: 'Success',
                text: data.success,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigateByUrl('/super_admin');
                }
              })
            }
          },
          err => {
            console.error(err);
          }
        );
      } else if (this.Type === 2) {

        this.auth.update(this.credentials).subscribe(
          (data) => {

            if (data.code === 200) {
             
              Swal.fire({
                title: 'Success',
                text: data.success,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigateByUrl('/admin');
                }
              })
              
            }
          },
          err => {
            console.error(err);
          }
        );
      } else if (this.Type === 3) {

        this.auth.update(this.credentials).subscribe(
          (data) => {

            if (data.code === 200) {
              Swal.fire({
                title: 'Success',
                text: data.success,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigateByUrl('/test_scheduler');
                }
              })
              
            }
          },
          err => {
            console.error(err);
          }
        );
      } else if (this.Type === 4) {

        this.testtakerservice.update_test_taker(this.credentials).subscribe(
          (data) => {

            if (data.code === 200) {
              
              Swal.fire({
                title: 'Success',
                text: data.success,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigateByUrl('/test_taker');
                }
              })
            }
          },
          err => {
            console.error(err);
          }
        );
      }
    }
  }

  Oncancel() {
    if (this.Role === 1) {
      this.router.navigateByUrl('/super_admin');
    } else if (this.Role === 2) {
      this.router.navigateByUrl('/admin');
    } else if (this.Role === 3) {
      this.router.navigateByUrl('/test_scheduler');
    } else if (this.Role === 4) {
      this.router.navigateByUrl('/test_taker');
    }
  }
}
